module.exports = __webpack_public_path__ + "img/logo.155b9c63.jpg";